<template>
  <v-card class="pa-4" outlined>
    <v-btn class="btn-close" icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    <h3 class="mb-4 text-capitalize error--text">{{ isAll ? 'Delete all templates' : 'Delete template' }}</h3>
    <p style="opacity: 0.8">
      Are you sure you want to delete {{ isAll ? 'this template' : 'all templates' }} review?
      {{ isAll ? 'This template' : 'All templates' }} will be permanently removed. This action cannot be undone.
    </p>
    <div class="d-flex justify-end">
      <v-btn :disabled="loading" color="error" @click="$emit('close')" text dark>Cancel</v-btn>
      <v-btn color="error" :loading="loading" @click="onDelete" text dark>Delete</v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '@/common/api.service'

export default {
  props: ['reviewTemplate', 'isAll'],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onDelete() {
      try {
        this.loading = true
        if (this.isAll) await ApiService.delete('/reviews/review-template/all')
        else await ApiService.post('/reviews/review-template/some', {ids: this.reviewTemplate._id})
        this.$emit('close')
      } catch (error) {
        console.log('🚀 ~ file: delete-payment.vue:30 ~ onDelete ~ error:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  position: relative;
  button.btn-close {
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
